import { GroundingSource } from "./ChatSourcesList";

export type ChatTurn = {
  userTranscript: string;
  assistantTranscript: string;
  messageId?: string;
  cacheName?: string;
  groundingSources?: GroundingSource[];
  timestamp?: string;
};

export const CHATBOT_STOPPED_MESSAGE = "You stopped this response";
